import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-accounts-dollar-parser',
    templateUrl: './accounts-dollar-parser.component.html',
    styleUrls: ['./accounts-dollar-parser.component.scss'],
    standalone: false
})
export class AccountsDollarParserComponent implements OnChanges {
  @Input() dollarAmount: number;
  @Input() isDisplayingDecimalSeparator = true;
  @Input() testId?: string;
  dollarSymbol: string;
  dollars: string;
  cents: string;

  constructor(private readonly currencyPipe: CurrencyPipe) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dollarAmount.firstChange) {
      const currentVal = changes.dollarAmount?.currentValue ?? 0;
      const formattedCurrency = this.currencyPipe.transform(currentVal);
      this.dollarSymbol = formattedCurrency.charAt(0);
      const currencySplit = formattedCurrency.slice(1).split('.');
      this.dollars = currencySplit[0] ?? '0';
      this.cents = currencySplit[1] ?? '00';
    }
  }
}
